import React, { useEffect, useState } from "react";
import { getStorage, ref, listAll, getDownloadURL } from "firebase/storage";
import CardIndividual from "../CardIndividual/CardIndividual";
import Loader from '../Loader/Loader';
import NavigationButtons from '../NavigationButtons/NavigationButtons';
import "./Usados.css";
import { useNavigate } from 'react-router-dom';
import WhatsApp from "../WhatsApp/WhatsApp";

const Usados = () => {
  const [imageUrls, setImageUrls] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const storage = getStorage();
    const folderRef = ref(storage, "Autos/Usados"); 

    listAll(folderRef)
      .then((res) => {
        // Get the first image and JSON data from each subfolder
        return Promise.all(
          res.prefixes.map((folder) => {
            return listAll(folder).then((res) => {
              // Filter out JSON files for images
              const imageFiles = res.items.filter(
                (item) => !item.name.endsWith(".json")
              );
              
              // Find JSON file
              const jsonFile = res.items.find(
                (item) => item.name.endsWith(".json")
              );

              if (imageFiles.length > 0) {
                return getDownloadURL(imageFiles[0]).then((imageUrl) => {
                  const vehicleInfo = {
                    url: imageUrl,
                    name: folder.name, // Nombre de la carpeta como fallback
                    folderName: folder.name
                  };

                  // Si hay JSON, obtener los datos del vehículo
                  if (jsonFile) {
                    return getDownloadURL(jsonFile).then((jsonUrl) => {
                      return fetch(jsonUrl)
                        .then((response) => response.json())
                        .then((jsonData) => ({
                          ...vehicleInfo,
                          modelo: jsonData.Modelo || folder.name, // Usar modelo del JSON o nombre de carpeta
                          marca: jsonData.Marca,
                          año: jsonData.Año
                        }))
                        .catch((error) => {
                          console.error("Error reading JSON for", folder.name, error);
                          return vehicleInfo; // Retornar info básica si falla el JSON
                        });
                    });
                  } else {
                    return vehicleInfo; // No hay JSON, usar info básica
                  }
                });
              }
            });
          })
        );
      })
      .then((urls) => {
        setImageUrls(urls.filter(Boolean)); // Filtrar elementos nulos/undefined
        setIsLoading(false);
        window.scrollTo(0, 0);
      })
      .catch(console.error);
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300">
        {isLoading ? <Loader isLoading={isLoading}/> :
        <>
          <div className="container mx-auto px-4 py-8">
            <h2 className="text-center text-4xl font-bold text-gray-900 mt-4 mb-8">
              USADOS SELECCIONADOS
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
              {imageUrls.map((vehicle, index) => (
                <div key={vehicle.folderName || vehicle.name} className="flex items-center justify-center">
                  <CardIndividual
                    image={vehicle.url}
                    name={vehicle.modelo || vehicle.name}
                    onInfoClick={() => navigate(`/Usados/${vehicle.folderName || vehicle.name}`)}
                  />
                </div>
              ))}
            </div>
            
            <div className="max-w-4xl mx-auto text-center bg-gradient-to-r from-gray-200 to-gray-300 rounded-3xl p-8 shadow-xl border border-gray-400">
              <h4 className="text-3xl font-bold text-gray-900 mb-6">
                Calidad Garantizada
              </h4>
              <div className="text-justify max-w-2xl mx-auto">
                <p className="text-lg text-gray-700 font-medium leading-relaxed">
                  Seleccionamos cuidadosamente nuestras unidades para ofrecer la mejor variedad de 
                  vehículos usados a nuestros clientes, garantizando que comprar con nosotros sea una 
                  experiencia única.
                </p>
              </div>
            </div>
          </div>
          
          <WhatsApp />    
          <NavigationButtons/>
        </>
        }
      </div>
      
      <style jsx global>{`
        body {
          background: linear-gradient(to bottom right, #f3f4f6, #e5e7eb, #d1d5db) !important;
        }
      `}</style>
    </>
  );
};

export default Usados;